import Button from 'components/control/button';
import ClockIcon from 'components/icon/clock-icon';
import styles from './price-history-button.module.scss';

export interface PriceHistoryButtonProps {
  /** Pre-formatted button label */
  label: string;
  /** Click handler to scroll to price history section */
  onClick?: () => void;
  /** Optional className for styling */
  className?: string;
}

/**
 * PriceHistoryButton - Button that scrolls to price history section
 * 
 * @example
 * ```tsx
 * <PriceHistoryButton
 *   label="Price History"
 *   onClick={() => scrollToPriceHistory()}
 * />
 * ```
 */
export function PriceHistoryButton({
  label,
  onClick,
  className,
}: PriceHistoryButtonProps) {
  return (
    <a
      onClick={onClick}
      className={className || styles.buttonWrapper}
      data-testid="ui-price-history-button"
    >
      <Button
        label={label}
        theme="secondary"
        Icon={ClockIcon}
      />
    </a>
  );
}

export default PriceHistoryButton;
